<template>
  <div class="TsuriGassyku-wrapper">
    <div v-rellax data-rellax-speed="-0.4" data-rellax-percentage="0.5" class="ocean-iso-bg-img"
      :style="{ backgroundImage: 'linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.6)), url(' + require('@/assets/img/home/tsurigassyuku.png') + ')' }">
    </div>
    <div v-scroll-animation class="tsurigassyuku-desc-wrapper scroll-animation">
      <h2 class="p-tsurigassyuku-title">伊豆大島 釣り合宿の記録</h2>
      <p class="p-tsurigassyuku-text">
        胸にかかった靄に不透明な詰まりを感じたら、ここにいればいい。<br>
        ゆっくりとした呼吸を思い出し、自然な細胞にいれかえて、視界が澄めば感覚に精彩がよみがえる。
      </p>
      <p class="p-tsurigassyuku-text">
        私たちはこの感覚を描き出すことで意義深さを与え、把握しよう。
      </p>
      <p class="p-tsurigassyuku-text">
        このサイトにはそれを記した。
      </p>
    </div>
    <div v-rellax data-rellax-speed="0.6" data-rellax-percentage="-3.5" class="tsurigassyuku-img">
        <img src="@/assets/img/home/sunset_view_from_the_ship.jpg" alt="さるびあ丸からの夕日">
    </div>
  </div>
</template>

<style scoped>
.TsuriGassyku-wrapper {
  position: relative;
  height: 100vh;
  width: 100%;
}

.ocean-iso-bg-img {
  position: relative;
  width: 100%;
  height: 70%;
  background-position: center center;
  background-size: cover;
}

.tsurigassyuku-desc-wrapper {
  position: absolute;
  top: 10%;
  left: 55%;
  display: flex;
  flex-direction: column;
}

.p-tsurigassyuku-title {
  font-family: "ShipporiMinchoBold";
  font-size: 22px;
  margin-bottom: 75px;
  color: rgba(230, 230, 230, 0.9);
}

.p-tsurigassyuku-text {
  font-family: "ShipporiMincho";
  font-size: 15px;
  margin-bottom: 1px;
  color: rgba(237, 237, 237, 0.9);
  line-height: 1.8rem;
  width: 90%;
}

.tsurigassyuku-img {
  position: absolute;
  top: 45%;
  left: 15%;
  z-index: 2;
}

.tsurigassyuku-img img {
  width: 300px;
  height: 360px;
  object-fit: cover;
  box-shadow:
    1.6px 1.8px 2.7px rgba(0, 0, 0, 0.056),
    4.2px 4.4px 6.9px rgba(0, 0, 0, 0.08),
    8.5px 9px 14.2px rgba(0, 0, 0, 0.1),
    17.5px 18.6px 29.2px rgba(0, 0, 0, 0.124),
    48px 51px 80px rgba(0, 0, 0, 0.18);
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .tsurigassyuku-desc-wrapper {
    left: 50%;
    width: 48%;
  }

  .p-tsurigassyuku-title {
    font-size: 16px;
    font-weight: 700;
  }

  .p-tsurigassyuku-text {
    font-size: 14px;
  }

  .tsurigassyuku-img img {
    width: 200px;
    height: 260px;
    transform: translateY(80px);
  }
}

@media screen and (max-width: 570px) {
  .tsurigassyuku-desc-wrapper {
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    width: 75%;
  }

  .p-tsurigassyuku-title {
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
  }

  .p-tsurigassyuku-text {
    font-size: 12px;
    line-height: 1.9em;
    width: 100%;
  }

  .tsurigassyuku-img {
    top: 64%;
    left: 30%;
  }

  .tsurigassyuku-img img {
    width: 170px;
    height: 230px;
  }
}
</style>